// Input to the staff `quoteShipment` callable (04 §4.7, 03 §3.3). The result is the domain
// `QuoteResult | QuoteFailure` from @ecobox/domain/pricing: the server always re-prices.
import { z } from 'zod';
import type { QuoteFailure, QuoteResult } from '@ecobox/domain';
import {
  branchCodeSchema,
  SERVICES,
  serviceLineSchema,
  sizeCodeSchema,
  slugSchema,
} from './config';

const dimsSchema = z
  .object({
    l: z.number().positive().max(1000),
    w: z.number().positive().max(1000),
    h: z.number().positive().max(1000),
  })
  .strict();

export const quoteBoxSchema = z
  .object({
    sizeId: sizeCodeSchema,
    /** Measured weight; the size's quote weight is used when absent. */
    weightKg: z.number().positive().max(500).optional(),
    /** Measured size; needed for ODD boxes priced by volume and for volumetric weight. */
    dimsCm: dimsSchema.optional(),
  })
  .strict();

export const quoteShipmentInputSchema = z
  .object({
    originBranchId: branchCodeSchema,
    service: z.enum(SERVICES),
    serviceLine: serviceLineSchema.optional(),
    destinationCityId: slugSchema,
    boxes: z.array(quoteBoxSchema).min(1).max(200),
    declaredValueMinor: z.number().int().nonnegative().max(1e12).optional(),
    addOnCodes: z
      .array(z.string().regex(/^[a-z_]{2,30}$/))
      .max(20)
      .optional(),
  })
  .strict();

export type QuoteShipmentInput = z.infer<typeof quoteShipmentInputSchema>;
export type QuoteShipmentOutput = QuoteResult | QuoteFailure;
